import React from "react";
import { Link } from "react-router-dom";
import { URL_Route } from "urlRouts";
interface Props {
  TableContent: any;
  HeaderMinWidth?: Array<any>;
}

const PanelApprovedProperties: React.FC<Props> = ({ TableContent, HeaderMinWidth }) => {
  return (
    <>
      {TableContent.map((item: any, key: any) => (
        <div
          key={key}
          style={{
            borderBottom:
              key === TableContent.length - 1 ? "none" : "1px solid #f6f6f6",
          }}
          className="table-content"
        >
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[0] : '' }}>{item.regionTitle +', '+ item.buildingArea}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[1] : '' }}>{item.propertyTitle}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[2] : '' }}>{item.writeDate}</p>
          <p style={{minWidth: HeaderMinWidth !== undefined ? HeaderMinWidth[3] : '' }}><Link className="" to={URL_Route.Edit_Property+`?property-id=${item.id}`}>Edit</Link></p>
        </div>
      ))}
    </>
  );
};

export default PanelApprovedProperties;
